<iframe style="margin: 10px 0" frameborder="0" border="0" width="100%" height="800" 
  src="https://app.powerbi.com/view?r=eyJrIjoiNzhiM2I3OTktMzE3My00YWNkLWI4ZDktMDljYzM0MjdjZjdlIiwidCI6IjY3N2Q0MGUyLTA2ZmEtNGM0Yi1iN2UyLTM4NWQ4NjNjYjczOSJ9"
  ></iframe>
<div class="rodapeMapa"></div>